module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Your review has been uploaded.","subtitle":"Thank you for your valuable feedback.","reward":"{0} reward pending","my_reviews_button":"View my review"}}')
  delete Component.options._Ctor
}
